export const asList = (response) => {
  if (!response?.status)
    throw new Error(response?.message || "Unable to load inspection data.");
  return Array.isArray(response.data) ? response.data : [];
};

export const dateValue = (value) =>
  value ? new Date(value).getTime() || 0 : 0;
export const dateLabel = (value) =>
  dateValue(value)
    ? new Date(value).toLocaleDateString("en-US", {
        month: "short",
        day: "2-digit",
        year: "numeric",
      })
    : "—";
export const isOverdue = (row) =>
  !!dateValue(row.dueDate) &&
  dateValue(row.dueDate) < new Date().setHours(0, 0, 0, 0) &&
  !["Resolved", "Closed"].includes(row.status);

export const normalizeRecord = (type, item, review, users = [], plans = []) => {
  const userName = (id) =>
    users.find((user) => Number(user.id) === Number(id))?.fullName ||
    "Unassigned";
  const plan = plans.find(
    (value) => Number(value.id) === Number(review.inspectionPlanId)
  );
  const common = {
    key: `${review.id}-${item.id}`,
    reviewId: review.id,
    engagement:
      review.engagementDetail?.name ||
      review.engagementDetail?.engagementNo ||
      "—",
    engagementNo: review.engagementDetail?.engagementNo || "—",
    inspection: review.inspectionNo || "—",
    client: review.engagementDetail?.client?.clientName || "—",
    cycle: plan?.inspectionCycleName || "—",
  };
  if (type === "queries") {
    const raw = String(item.status || "");
    return {
      ...common,
      id: item.id || `Q-${item.queryId}`,
      title: item.subject || "Untitled query",
      description: item.details || "",
      priority: item.priority || "Low",
      status: /resolv/i.test(raw)
        ? "Resolved"
        : /await|open/i.test(raw)
        ? "Open"
        : "In Progress",
      assignee: item.assigneeName || userName(item.assigneeId),
      assigneeId: item.assigneeId,
      createdBy: item.createdBy,
      dueDate: item.dueDate,
      createdOn: item.createdOn,
      updatedOn: item.updatedOn || item.createdOn,
    };
  }
  if (type === "findings") {
    const status = String(item.findingStatus || "Open");
    return {
      ...common,
      id: item.findingNumber || `F-${item.id}`,
      title: item.title || "Untitled finding",
      description: item.description || "",
      severity: item.severity || "Low",
      status: status === "InReview" ? "In Progress" : status,
      assignee: userName(item.ownerUserId || item.responseRequestedFromUserId),
      assigneeId: item.ownerUserId || item.responseRequestedFromUserId,
      createdOn: item.createdOn,
      dueDate: item.responseDueDate,
      updatedOn: item.updatedOn || item.createdOn,
    };
  }
  const reportStatus = /trigger final-sign-off/i.test(item.description || "")
    ? "Completed"
    : /trigger review-completion/i.test(item.description || "")
    ? "Under Review"
    : "Completed";
  return {
    ...common,
    id: `R-${item.id}`,
    title: item.name || item.fileName || "Generated report",
    fileName: item.fileName || item.name || "report.pdf",
    reportType: /summary/i.test(item.name || item.fileName || "")
      ? "Summary Report"
      : "Final Report",
    status: reportStatus,
    createdOn: item.createdOn,
    updatedOn: item.updatedOn,
    documentId: item.id,
  };
};

export const csvCell = (value) => {
  const text = String(value ?? "");
  const safe = /^[\s]*[=+@-]/.test(text) ? `'${text}` : text;
  return `"${safe.replace(/"/g, '""')}"`;
};
